<mat-dialog-content [ngClass]="{ 'modal-content': !showAlternateIntroPop, 'intro-popup': showAlternateIntroPop }" class="" id="welcome-carousel">
  <!-- <button class="close-button" (click)="closeModal()"> -->
    <!-- // need change -->
    <button class="close-button" (click)="closeModal()">
    <img [src]="closeIcon" alt="close-icon" />
  </button> 
  
  <ng-container *ngIf="!showAlternateIntroPop && !smioneLoginRestrictmodalTrue; else alternatePopup">
    <!-- Default Carousel -->
    <div class="modal-parent-container">
      <div class="carousel">
        <div class="carousel-text-container">
          <h5 class="slider-heading" [innerHTML]="slides[currentSlideIndex]?.title"></h5>
          <p class="slider-sub-heading" [innerHTML]="slides[currentSlideIndex]?.description"></p>
        </div>
        <div class="dots-container">
          <span *ngFor="let slide of slides; let i = index" class="dot" [class.active]="i === currentSlideIndex"
            (click)="goToSlide(i)"></span>
        </div>
        <img [src]="slides[currentSlideIndex]?.image" alt="Slide Image" class="carousel-image" loading="lazy" />
      </div>
      <div class="button-container">
        <button class="letsgo-button" (click)="letsgoButton()">{{'LEARN_MORE' | translate}}</button>
        <button *ngIf="isSkipUpgradeKudzu" class="maybe-later-button" (click)="closeModalMaybeLater()">{{'MAYBE_LATER' | translate}}</button>
      </div>
    </div>
  </ng-container>

  <ng-template #alternatePopup>
    <ng-container *ngIf="showAlternateIntroPop; else smioneLoginPopup">
      <!-- Alternate Popup -->
      <div class="modal-parent-container">
        <div class="carousel">
          <h5 class="slider-heading">
            <span class="unhighlighted-text">
  <span class="unhighlighted-text">{{ 'Grow_your' | translate }}</span>
  <span class="highlight-text">{{ 'KUDZU' | translate }}</span>
  <span class="unhighlighted-text">{{ 'mobile_app' | translate }}</span>
</span>

          </h5>
          <p class="slider-sub-heading">{{'KUDZU_IS_AN_ONLINE' | translate}}</p>
          <img src="assets/images/Carousal_image.png" alt="Slide Image" class="carousel-image" loading="lazy" />
          <div class="button-container">
            <button class="letsgo-button" (click)="letsgoButton()">{{'GET_GROWING' | translate}}</button>
            <button *ngIf="isSkipUpgradeKudzu" class="maybe-later-button" (click)="closeModalMaybeLater()">{{'MAYBE_LATER' | translate}}</button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #smioneLoginPopup>
    <div class="modal-parent-container">
      <div class="carousel">
        <h5 class="slider-heading">
          {{'PLEASE_LOG_INTO_KUDZU' | translate}}
        </h5>
        <p class="kudzu-popup-sub-heading">
          {{'YOU_CAN_NOW_ACCESS' | translate}} <span class='highlight-text'>{{'SMIONE' | translate}}</span> {{'ACCOUNT_ON_THE' | translate}}
        </p>
        <img src="assets/images/kudzu_logo.png" alt="restrict-logo" class="kudzu-image" loading="lazy" />
        <div class="kudzu-button-container">
          <button class="login-button" (click)="logitoKudzu()">{{'LOGIN' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>
